import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodNameService {
  constructor() { }

  getName(paymentMethod: string) {
    if (paymentMethod == 'firstdata' || paymentMethod == 'cashflows' || paymentMethod == 'trustpayments' || paymentMethod == 'checkout') {
      return 'Debit/Credit Card';
    }
    if (paymentMethod == 'paypal') {
      return 'PayPal';
    }
    if (paymentMethod == 'free') {
      return 'N/A';
    }
    if (paymentMethod == 'applepay') {
      return 'ApplePay (Debit/Credit Card)';
    }
    if (paymentMethod == 'googlepay') {
      return 'GooglePay (Debit/Credit Card)';
    }

    return 'Unknown';
  }
}
